import { Button, Space } from "antd";
import GreenCheckmark from "../../../assets/images/green-checkmark.png";
import CustomModal from "../../../components/ui/CustomModal";
import { ModalComponentProps } from "../../../types";

export default function DownloadSuccessModal({
  handleClose,
  ...rest
}: ModalComponentProps) {
  return (
    <CustomModal
      width={400}
      title=""
      {...rest}
      handleClose={handleClose}
      footer={null}
    >
      <div>
        <img src={GreenCheckmark} className="w-16 mb-4" alt="" />
        <div className="my-4 text-header text-base font-semibold">
          bKash Pay data Report Downloaded Successfully!
        </div>
        <p className="mb-4 text-display-body text-sm font-normal">
          Please Upload the downloaded bKash pay data report in bKash portal. If
          you do not have credentials/account for bKash disbursement portal
          please call{" "}
          <a href="tel:16516" className="!text-accent">
            16516
          </a>{" "}
          for support.
        </p>
        <Space className="w-full mt-2" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button type="primary" className="modal-button">
            Open bKash Portal
          </Button>
        </Space>
      </div>
    </CustomModal>
  );
}
